module.exports = __webpack_public_path__ + "img/Telegram.ab090489.svg";